import React, { useState, useRef, useEffect } from "react";
import * as CalendarHelper from "helpers/CalendarHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faArrowRightLong, faCartShopping } from "@fortawesome/free-solid-svg-icons";
import DatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./MultiCalendar.scss";

const MultiCalendar = ({ formatMessage, onBtnOkClick, onBtnChooseClick,
    onCalendarClick, btnOkId, btnChooseId, onDateAction, item, cartObjects, isCartSymbol = false }) => {
    const [excludedIn, setExcludedIn] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    
    const initIncludesDates = () => {
        const { itemsDateRangeObj } = cartObjects;
        if (cartObjects) {
            if (itemsDateRangeObj[item.id]) {
                let from = itemsDateRangeObj[item.id][0];
                let to = itemsDateRangeObj[item.id][1];
                let includes = [new Date(from), new Date(to)];
                return includes;
            }
        }
        return null;
    }

    const initExcludesDates = () => {
        if(cartObjects.curBlocksObj[item.id]){
            let times = cartObjects.curBlocksObj[item.id];
            console.log("LOGS: LAMTEST100 times", times);
            if(times && times.length){
                setBlocks(times);
                times = times.map(time => {
                    let startObj = CalendarHelper.parseDateStr(time.from);
                    let endObj = CalendarHelper.parseDateStr(time.to);
                    let start = new Date(startObj.year, startObj.month ,startObj.day)
                    let end = new Date(endObj.year, endObj.month , endObj.day)
                    return {start, end}
                });
                setExcludedIn(times);
            }
        }
    }

    const initSelectedDates = () => {
        if (cartObjects) {
            const { itemsCartList, itemsDateObj } = cartObjects;
            let found = itemsCartList.find(entry => entry.id == item.id);
            if (found) {
                let showdates = found.showdates;
                if (itemsDateObj && itemsDateObj[item.id]) showdates = itemsDateObj[item.id];
                return showdates && showdates.map(item => new Date(item));
            }
        }
        return null;
    }

    //const [includeDates, setIncludeDates] = useState(initIncludesDates);
    const [selectedDates, setSelectedDates] = useState(initSelectedDates);
    const calendarRef = useRef();

    const handleCalendar = () => {
        calendarRef.current.onInputClick();
        onCalendarClick();
    }

    const handleOkClick = () => {
        onBtnOkClick();
        calendarRef.current.toggleCalendar();
        onDateAction({ item, dates: selectedDates });
    }

    const setMax = (max) => {
        let maxObj = CalendarHelper.parseDateStr(max);
        setMaxDate(new Date(maxObj.year, maxObj.month ,maxObj.day));
    }

    const setMin = (min) => {
        let minObj = CalendarHelper.parseDateStr(min);
        setMinDate(new Date(minObj.year, minObj.month ,minObj.day));
    }

    const setDefault = () => {
        setMinDate(null);
        setMaxDate(null);
    }

    const handleCalendarChange = (dates) => {
        if(dates && dates.length == 1 && blocks && blocks.length > 0){
            let curDate = CalendarHelper.changeDateToStr({dates});
            if(curDate){
                let found;
                blocks.forEach((el,i) => {
                    if(!found){
                         if(parseInt(curDate) < parseInt(el.from)){
                            if(i>0){
                                let min = blocks[i-1].to;
                                if(min) setMin(min);
                            }
                            setMax(el.from);
                            found = true;
                        } else if(parseInt(curDate) > parseInt(el.to)){
                            if((i < (blocks.length-1) && parseInt(curDate) < parseInt(blocks[i+1].from)) ||
                            (i == (blocks.length-1))){
                                setMin(el.to)
                                if(i<blocks.length){
                                    if(blocks[i+1]){
                                        let max = blocks[i+1].from;
                                        setMax(max);
                                    }
                                }
                                 found = true;
                            }
                        }
                    }
                })
            }
        }
        if(dates && dates.length == 0) setDefault();
        setSelectedDates(dates);
    }

    useEffect(() => {
        setSelectedDates(initSelectedDates);
    }, [item.rentelid, cartObjects.itemsCartList])

    useEffect(() => {
        initExcludesDates();
    }, [cartObjects.curBlocksObj])

    const showStartEndDates = () => {
        if (selectedDates && selectedDates.length > 0) {
            const { start, end } = CalendarHelper.getStartEndDates({ selectedDates });
            return (
                <div style={CalendarHelper.CALENDAR_BOX}>
                    <div>{start}</div>
                    <div style={{ margin: "0 20px" }}>
                        {start && <FontAwesomeIcon icon={faArrowRightLong} />}
                    </div>
                    <div >{end}</div>
                </div>)
        }
    }

    const CustomContainer = ({ className, children }) => {
        return (
            <div style={CalendarHelper.CALENDAR_CONTAINER}>
                <CalendarContainer className={className}>
                    {showStartEndDates()}
                    <div style={{ position: "relative" }}>{children}</div>
                </CalendarContainer>
                <div>
                    <button style={CalendarHelper.CALENDAR_CHOOSE_BTN}
                        onClick={onBtnChooseClick}>
                        {formatMessage({ id: btnChooseId })}
                    </button>
                    <button style={CalendarHelper.CALENDAR_OK_BTN}
                        onClick={handleOkClick}>
                        {formatMessage({ id: btnOkId })}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="ui-multicalendar">
            <div className="uimulticalendar-box">
                <FontAwesomeIcon icon={isCartSymbol ? faCartShopping : faCalendarAlt} onClick={handleCalendar} />
            </div>
            <div className="uicalendar-box">
                <DatePicker ref={calendarRef} dateFormat="yyyy/MM/dd" locale="de"
                    selectedDates={selectedDates} selectsMultiple
                    onChange={handleCalendarChange} shouldCloseOnSelect={false}
                    calendarContainer={CustomContainer}
                    //includeDateIntervals={includeDates && [{ start: includeDates[0], end: includeDates[1] }]}
                     excludeDateIntervals={excludedIn}
                     minDate={minDate} maxDate={maxDate} 
                    monthsShown={2} popperPlacement="right-bottom" />
            </div>
        </div>

    )
}

export default MultiCalendar;